import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fe02db02&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fe02db02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe02db02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe02db02')) {
      api.createRecord('fe02db02', component.options)
    } else {
      api.reload('fe02db02', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fe02db02&scoped=true&", function () {
      api.rerender('fe02db02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvkRwuh3xHDX/JS/comp/PopupBox.vue"
export default component.exports